import { FlagsProvider } from '@atlaskit/flag';
import { AuthProvider } from 'core/providers/AuthProvider';
import { DialogProvider } from 'core/providers/DialogProvider';
import AppRouting from './core/routing/app-routing';
import { SharedDataProvider } from 'core/providers/SharedDataProvider';

function App() {
  return (
    <AuthProvider>
      <SharedDataProvider>
        <FlagsProvider>
          <DialogProvider>
            <AppRouting />
          </DialogProvider>
        </FlagsProvider>
      </SharedDataProvider>
    </AuthProvider>
  );
}

export default App;
